<div class="sidebar-container">
  <!-- BARRA SUPERIOR COMPACTA: Contador + Buscador + Filtros + Reset (una sola línea) -->
  <div class="top-bar-single-row">
    <!-- Contador de vehículos -->
    <div
      class="vehiculos-counter-compact"
      tooltip="Vehículos con reporte reciente"
    >
      <mat-icon class="counter-icon">directions_car</mat-icon>
      @if (textoBusqueda) {
        <span class="counter-value filtered">
          <span class="counter-partial">{{ coincidenciasBusqueda }}</span>
          <span class="counter-separator">/</span>
          <span class="counter-total">{{ totalVehiculos }}</span>
        </span>
      } @else if (vehiculos !== totalVehiculos) {
        <span class="counter-value filtered">
          <span class="counter-partial">{{ vehiculos }}</span>
          <span class="counter-separator">/</span>
          <span class="counter-total">{{ totalVehiculos }}</span>
        </span>
      } @else {
        <span class="counter-value">{{ totalVehiculos }}</span>
      }
    </div>

    <!-- Buscador -->
    <div class="buscador-wrapper-compact">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        type="text"
        class="buscador-input"
        placeholder="Buscar..."
        [(ngModel)]="textoBusqueda"
        (ngModelChange)="onBusquedaChange($event)"
      />
      @if (textoBusqueda) {
        <button
          irxBotonIcono
          tamano="mini"
          class="clear-button"
          (click)="limpiarBusqueda()"
          type="button"
          tooltip="Limpiar búsqueda"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <!-- Botón Filtros -->
    <button
      irxBotonIcono="borde"
      tamano="compacto"
      class="btn-filtros-compact"
      [activo]="hasFiltrosActivos"
      (click)="abrirDialogFiltros()"
      tooltip="Abrir filtros"
      type="button"
    >
      <mat-icon>filter_alt</mat-icon>
      @if (hasFiltrosActivos) {
        <span class="filter-badge"></span>
      }
    </button>

    <!-- Botón Reset -->
    <button
      irxBotonIcono
      tono="peligro"
      tamano="compacto"
      class="btn-reset-compact"
      (click)="resetearTodo()"
      tooltip="Resetear filtros y búsqueda"
      type="button"
      [disabled]="!hasFiltrosActivos && !textoBusqueda"
    >
      <mat-icon>restart_alt</mat-icon>
    </button>
  </div>

  <!-- SECCIÓN 1: GESTIÓN DE MAPAS-->
  <div class="sidebar-section gestion-mapas">
    <div class="section-header">
      <button
        class="irx-sin-estilo section-title-button"
        (click)="toggleGestionMapas()"
        [attr.aria-expanded]="gestionMapasOpen"
        type="button"
      >
        <h3 class="section-title">
          <mat-icon
            class="icon-map"
            style="
              font-size: 18px;
              width: 18px;
              height: 18px;
              color: var(--theme-primary-500);
            "
          >
            map
          </mat-icon>
          Gestión de Mapas
        </h3>
        <span class="chevron" [class.open]="gestionMapasOpen"></span>
      </button>
    </div>

    @if (gestionMapasOpen) {
      <div class="section-content">
        <!-- Selector de cantidad de mapas -->
        <div class="cantidad-mapas-section">
          <div class="cantidad-mapas-label">
            <mat-icon
              style="font-size: 16px; width: 16px; height: 16px; opacity: 0.7"
            >
              grid_view
            </mat-icon>
            <span>Cantidad de mapas</span>
            @if (mapaService.mapsRecreating$ | async) {
              <mat-spinner diameter="12" style="margin-left: 6px"></mat-spinner>
            }
          </div>
          <div class="cantidad-mapas-buttons">
            @for (num of mapOptionsCount; track num) {
              <button
                type="button"
                class="irx-celda map-count-btn"
                (click)="handleCantMapasChange(num)"
                [disabled]="mapaService.mapsRecreating$ | async"
                [attr.aria-pressed]="cantMapas === num"
                [attr.aria-label]="num + ' mapa' + (num > 1 ? 's' : '')"
                [tooltip]="num + ' mapa' + (num > 1 ? 's' : '')"
              >
                {{ num }}
              </button>
            }
          </div>
        </div>

        <!-- Selector del mapa activo -->
        <!-- @if (cantMapas > 1) {
        <div class="mapa-activo-section">
          <div class="mapa-activo-label">
            <mat-icon
              style="font-size: 16px; width: 16px; height: 16px; opacity: 0.7"
              >
              tab
            </mat-icon>
            <span>Mapa activo</span>
          </div>
          <div class="map-dots-container" [ngClass]="mapsClass">
            <button
              *ngFor="let m of mapOptionsSelected"
              type="button"
              class="map-dot-btn"
              [class.selected]="m === mapaSeleccionado"
              (click)="selectMapaByDot(m)"
              [attr.aria-pressed]="m === mapaSeleccionado"
              [attr.aria-label]="'Mapa ' + m"
              [tooltip]="'Mapa ' + m"
              >
              <span class="dot-number">{{ m }}</span>
            </button>
          </div>
        </div>
        } -->

        <!-- Separador visual -->
        <div class="section-divider"></div>

        <!-- Controles de mapa -->
        <div class="map-controls-section">
          <!-- Tipo de mapa, Ayuda y Tamaño de íconos en la misma fila -->
          <div class="control-row-split">
            <div class="control-half">
              <div class="control-label">
                <mat-icon
                  style="
                    font-size: 16px;
                    width: 16px;
                    height: 16px;
                    opacity: 0.7;
                  "
                >
                  layers
                </mat-icon>
                <span>Tipo de mapa</span>
              </div>
              <app-selector-tipo-mapa
                (tipoMapaBaseChange)="onTipoMapaBaseChange($event)"
                [mapasPersonalizados]="mapasPersonalizados"
                [tipoMapaBase]="tipoMapaBase"
                [tipoMapaBaseKey]="tipoMapaBaseKey"
                [useAbsolutePosition]="false"
              ></app-selector-tipo-mapa>
            </div>

            <!-- Botón de ayuda compacto -->
            <button
              irxBotonIcono="borde"
              tamano="compacto"
              tono="primario"
              class="help-button-compact"
              (click)="toggleHelp()"
              tooltip="Controles del mapa"
              type="button"
            >
              <mat-icon>help_outline</mat-icon>
            </button>

            <div class="control-half">
              <div class="control-label">
                <mat-icon
                  style="
                    font-size: 16px;
                    width: 16px;
                    height: 16px;
                    opacity: 0.7;
                  "
                >
                  pin_drop
                </mat-icon>
                <span>Tamaño de íconos</span>
                <span class="scale-value">
                  {{ escalaIconos | number: '1.1-1' }}x
                </span>
              </div>
              <mat-slider
                min="0.5"
                max="2"
                step="0.1"
                discrete
                [displayWith]="formatLabel"
                class="icon-scale-slider"
              >
                <input
                  matSliderThumb
                  [(ngModel)]="escalaIconos"
                  (ngModelChange)="onEscalaIconosChange($event)"
                />
              </mat-slider>
            </div>
          </div>

          <div class="control-row">
            <mat-slide-toggle
              [checked]="iconPitchAlignment === 'map'"
              (change)="
                onIconPitchAlignmentChange($event.checked ? 'map' : 'viewport')
              "
              color="primary"
            >
              Inclinar elementos con la vista
            </mat-slide-toggle>
          </div>

          <div class="control-row">
            <mat-slide-toggle
              [checked]="animacionesActivas"
              (change)="onAnimacionesActivasChange($event.checked)"
              color="primary"
            >
              Animar movimiento de vehículos (experimental)
            </mat-slide-toggle>
          </div>

          @if (helper.clienteTraficoHabilitado) {
            <div class="control-row">
              <mat-slide-toggle
                [checked]="helper.mapaTraficoEnabled"
                (change)="helper.toggleMapaTrafico()"
                color="primary"
              >
                Tráfico
              </mat-slide-toggle>
            </div>
          }
        </div>

        <!-- Popup de ayuda -->
        @if (showHelp) {
          <div class="help-popup-overlay" (click)="toggleHelp()">
            <div class="help-popup-content" (click)="$event.stopPropagation()">
              <div class="help-header">
                <h4>Controles del Mapa</h4>
                <button
                  irxBotonIcono
                  tooltip="Cerrar"
                  tamano="compacto"
                  (click)="toggleHelp()"
                  class="close-help-btn"
                  type="button"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <div class="help-items">
                <div class="help-item">
                  <div class="help-icon">
                    <span class="material-icons">refresh</span>
                  </div>
                  <div class="help-content">
                    <strong>Rotar</strong>
                    <span>Alt + Shift + Click + Arrastrar</span>
                  </div>
                </div>
                <div class="help-item">
                  <div class="help-icon">
                    <span class="material-icons">search</span>
                  </div>
                  <div class="help-content">
                    <strong>Zoom</strong>
                    <span>Rueda del mouse</span>
                  </div>
                </div>
                <div class="help-item">
                  <div class="help-icon">
                    <span class="material-icons">crop_free</span>
                  </div>
                  <div class="help-content">
                    <strong>Zoom en zona</strong>
                    <span>Shift + Click + Arrastrar</span>
                  </div>
                </div>
                <div class="help-item">
                  <div class="help-icon">
                    <span class="material-icons">pan_tool</span>
                  </div>
                  <div class="help-content">
                    <strong>Mover</strong>
                    <span>Click + Arrastrar</span>
                  </div>
                </div>
                <div class="help-item">
                  <div class="help-icon">
                    <span class="material-icons">north</span>
                  </div>
                  <div class="help-content">
                    <strong>Zoom rápido</strong>
                    <span>Doble click</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- Separador visual -->
        <div class="section-divider"></div>

        <!-- TOGGLES DE VISIBILIDAD EN UNA SOLA LÍNEA -->
        <div class="visibility-toggles-section">
          <div class="control-label" style="margin-bottom: 4px">
            <mat-icon
              style="font-size: 16px; width: 16px; height: 16px; opacity: 0.7"
            >
              visibility
            </mat-icon>
            <span>Mostrar en el mapa</span>
          </div>
          <div class="visibility-toggles-container">
            <!-- VEHÍCULOS -->
            <div class="toggle-group-inline">
              <irx-segmentado class="visibility-toggle-group" tamano="compacto">
                <irx-segmento
                  (click)="
                    mostrarVehiculos = !mostrarVehiculos;
                    onToggleMostrarVehiculos()
                  "
                  [title]="'Mostrar/Ocultar vehículos'"
                  [activo]="mostrarVehiculos"
                >
                  <mat-icon>directions_car</mat-icon>
                </irx-segmento>

                <irx-segmento
                  (click)="onToggleMostrarNombreVehiculos()"
                  [title]="
                    mostrarNombreVehiculos === 'ninguno'
                      ? 'Ocultar nombres de vehículos'
                      : mostrarNombreVehiculos === 'todos'
                        ? 'Mostrar nombres de todos los vehículos'
                        : 'Mostrar nombre del vehículo seleccionado'
                  "
                >
                  <mat-icon>
                    {{
                      mostrarNombreVehiculos === 'ninguno'
                        ? 'match_case_off'
                        : mostrarNombreVehiculos === 'todos'
                          ? 'match_case'
                          : 'uppercase'
                    }}
                  </mat-icon>
                </irx-segmento>

                <irx-segmento
                  (click)="
                    seguimientoActivo = !seguimientoActivo;
                    onToggleSeguimiento()
                  "
                  [title]="'Seguir vehículo seleccionado'"
                  [activo]="seguimientoActivo"
                >
                  <mat-icon>gps_fixed</mat-icon>
                </irx-segmento>

                <irx-segmento
                  (click)="onCategoriaMarkerChange()"
                  [title]="
                    categoriaMarker === 'tipo'
                      ? 'Mostrar por tipo de vehículo'
                      : 'Mostrar por función de vehículo'
                  "
                >
                  <mat-icon>
                    {{ categoriaMarker === 'tipo' ? 'local_shipping' : 'work' }}
                  </mat-icon>
                </irx-segmento>

                <irx-segmento
                  (click)="onMostrarFotoChange()"
                  [title]="
                    mostrarFoto === 'no'
                      ? 'Mostrar foto completa'
                      : mostrarFoto === 'completo'
                        ? 'Mostrar foto centrada'
                        : 'Ocultar foto'
                  "
                  [activo]="mostrarFoto !== 'no'"
                >
                  <mat-icon>
                    {{
                      mostrarFoto === 'no'
                        ? 'photo_camera'
                        : mostrarFoto === 'completo'
                          ? 'fit_screen'
                          : 'crop_free'
                    }}
                  </mat-icon>
                </irx-segmento>

                <irx-segmento
                  (click)="onUsarCoordenadasSnappedChange()"
                  [title]="
                    usarCoordenadasSnapped
                      ? 'Posición ajustada a calles en los vehículos en marcha; los apagados en su posición GPS (activo)'
                      : 'Posición GPS original (activo)'
                  "
                  [activo]="usarCoordenadasSnapped"
                >
                  <mat-icon>
                    {{ usarCoordenadasSnapped ? 'edit_road' : 'satellite_alt' }}
                  </mat-icon>
                </irx-segmento>
              </irx-segmentado>
            </div>

            <!-- UBICACIONES -->
            <div class="toggle-group-inline">
              <irx-segmentado class="visibility-toggle-group" tamano="compacto">
                <irx-segmento
                  (click)="
                    mostrarUbicaciones = !mostrarUbicaciones;
                    onToggleMostrarUbicaciones()
                  "
                  [activo]="mostrarUbicaciones"
                  [title]="'Mostrar/Ocultar ubicaciones'"
                >
                  <mat-icon>crop_free</mat-icon>
                </irx-segmento>

                <irx-segmento
                  (click)="onToggleMostrarNombreUbicaciones()"
                  [title]="
                    mostrarNombreUbicaciones === 'ninguno'
                      ? 'Mostrar nombres de ubicaciones'
                      : 'Ocultar nombres de ubicaciones'
                  "
                >
                  <mat-icon>
                    {{
                      mostrarNombreUbicaciones === 'ninguno'
                        ? 'match_case_off'
                        : 'match_case'
                    }}
                  </mat-icon>
                </irx-segmento>
              </irx-segmentado>
            </div>

            <!-- RECORRIDOS -->
            <div class="toggle-group-inline">
              <irx-segmentado class="visibility-toggle-group" tamano="compacto">
                <!-- Cicla ninguno → todos → sólo el del vehículo seleccionado -->
                <irx-segmento
                  (click)="onToggleMostrarRecorridos()"
                  [activo]="mostrarRecorridos !== 'ninguno'"
                  [title]="tooltipMostrarRecorridos"
                >
                  <mat-icon>{{ iconoMostrarRecorridos }}</mat-icon>
                </irx-segmento>

                <irx-segmento
                  (click)="onToggleMostrarNombreRecorridos()"
                  [title]="
                    mostrarNombreRecorridos === 'ninguno'
                      ? 'Mostrar nombres de recorridos'
                      : 'Ocultar nombres de recorridos'
                  "
                >
                  <mat-icon>
                    {{
                      mostrarNombreRecorridos === 'ninguno'
                        ? 'match_case_off'
                        : 'match_case'
                    }}
                  </mat-icon>
                </irx-segmento>
              </irx-segmentado>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- SECCIÓN 2: DETALLES DEL VEHÍCULO -->
  <div class="sidebar-section detalles-vehiculo">
    <div class="section-header">
      <button
        class="irx-sin-estilo section-title-button"
        type="button"
        (click)="toggleDetallesVehiculo()"
        [attr.aria-expanded]="detallesVehiculoOpen"
        aria-controls="panel-detalles-vehiculo"
      >
        <h3 class="section-title">
          <mat-icon
            style="
              font-size: 18px;
              width: 18px;
              height: 18px;
              color: var(--theme-primary-500);
            "
          >
            info
          </mat-icon>
          Detalles del Vehículo
        </h3>
        <span class="chevron" [class.open]="detallesVehiculoOpen"></span>
      </button>
    </div>

    <div
      id="panel-detalles-vehiculo"
      class="section-content"
      [hidden]="!detallesVehiculoOpen"
    >
      <div class="scroll-wrapper">
        @if (reporteLocal) {
          <!-- Detalles del vehículo -->
          <app-info-vehiculo
            [reporte]="reporteLocal"
            (reporteChange)="handleReporteChange($event)"
            (reporteVerChange)="handleReporteVerChange($event)"
          ></app-info-vehiculo>

          <!-- Detalles del reporte -->
          @if (verDetallesReporte) {
            <app-info-reporte
              [(reporte)]="reporteLocal"
              (reporteChange)="closeDetalleReporte()"
              (salirDetalleChange)="closeDetalleReporte()"
            ></app-info-reporte>
          }
        } @else {
          <app-empty-state
            title="Seleccioná un vehículo para ver sus detalles"
          ></app-empty-state>
          <!-- <div class="empty-state">
          <i class="icon-info-circle"></i>
          <p>Seleccioná un vehículo para ver sus detalles</p>
        </div> -->
        }
      </div>
    </div>
  </div>

  <!-- Sección 4: BÚSQUEDA ESPECÍFICA (contextual según lo seleccionado) -->
  <div class="sidebar-section busqueda-especifica">
    <div class="section-header">
      <button
        class="irx-sin-estilo section-title-button"
        type="button"
        (click)="toggleBusquedaSection()"
        [attr.aria-expanded]="busquedaSectionOpen"
        aria-controls="panel-busqueda-section"
      >
        <h3 class="section-title">
          <mat-icon
            style="
              font-size: 18px;
              width: 18px;
              height: 18px;
              color: var(--theme-primary-500);
            "
          >
            search
          </mat-icon>
          Búsqueda
        </h3>
        <span
          class="chevron"
          [class.open]="busquedaSectionOpen"
          aria-hidden="true"
        ></span>
      </button>
    </div>

    @if (busquedaSectionOpen) {
      <div id="panel-busqueda-section" class="section-content">
        <!-- Qué acota las búsquedas visibles: zona y vehículo pueden convivir -->
        @if (tituloUbicacionSeleccionada || tituloVehiculoSeleccionado) {
          <div class="contexto-chips">
            @if (tituloUbicacionSeleccionada) {
              <div class="contexto-chip">
                <mat-icon class="contexto-icon">location_on</mat-icon>
                <span class="contexto-texto">
                  {{ tituloUbicacionSeleccionada }}
                </span>
                <button
                  irxBotonIcono
                  tamano="mini"
                  class="contexto-limpiar"
                  type="button"
                  (click)="limpiarUbicacionSeleccionada()"
                  tooltip="Soltar la zona seleccionada"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }

            @if (tituloVehiculoSeleccionado) {
              <div class="contexto-chip">
                <mat-icon class="contexto-icon">directions_car</mat-icon>
                <span class="contexto-texto">
                  {{ tituloVehiculoSeleccionado }}
                </span>
                <button
                  irxBotonIcono
                  tamano="mini"
                  class="contexto-limpiar"
                  type="button"
                  (click)="limpiarVehiculoSeleccionado()"
                  tooltip="Soltar el vehículo seleccionado"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }

        <div class="busqueda-contextual">
          @switch (contextoBusqueda) {
            @case ('vehiculo') {
              <app-busqueda-vehiculo-recorridos></app-busqueda-vehiculo-recorridos>
            }
            @case ('ubicacion') {
              <app-busqueda-zona
                [contextoZona]="'ubicacion'"
                [hayVehiculo]="!!reporteLocal"
              ></app-busqueda-zona>
            }
            @default {
              <!-- Sin nada seleccionado: la vía principal es seleccionar algo
                   en el mapa; buscar por dirección es la alternativa -->
              <div class="busqueda-vacia">
                <mat-icon class="busqueda-vacia-icon">touch_app</mat-icon>
                <p class="busqueda-vacia-texto">
                  Seleccioná un vehículo y/o una zona en el mapa
                </p>
              </div>

              <div class="busqueda-vacia-separador">
                <span>o</span>
              </div>

              <button
                irxBoton="tonal"
                tamano="compacto"
                bloque
                class="busqueda-vacia-toggle"
                type="button"
                (click)="toggleBusquedaDireccion()"
                [attr.aria-expanded]="busquedaDireccionOpen"
              >
                <mat-icon class="busqueda-vacia-toggle-icon">place</mat-icon>
                <span>Buscar por dirección</span>
                <span
                  class="chevron"
                  [class.open]="busquedaDireccionOpen"
                  aria-hidden="true"
                ></span>
              </button>

              @if (busquedaDireccionOpen) {
                <app-busqueda-zona
                  [contextoZona]="'sin-seleccion'"
                  [hayVehiculo]="false"
                ></app-busqueda-zona>
              }
            }
          }
        </div>
      </div>
    }
  </div>
</div>
